import { OpsEstateRoute } from '@/modules/ops/constants/OpsEstateRoute';

export const router = [
  {
    name: OpsEstateRoute.DASHBOARD.name,
    path: OpsEstateRoute.DASHBOARD.path,
    component: () => import('@/modules/ops/pages/EstateOpsDashboardPage.vue')
  },
  {
    name: OpsEstateRoute.DETAILS.name,
    path: OpsEstateRoute.DETAILS.path,
    component: () => import('@/modules/ops/pages/EstateOpsDetailsPage.vue')
  },
  {
    name: OpsEstateRoute.SETTLEMENT.name,
    path: OpsEstateRoute.SETTLEMENT.path,
    component: () => import('@/modules/ops/pages/EstateSettlementPage.vue'),
    children: [
      {
        name: OpsEstateRoute.SETTLEMENT_CANADA.name,
        path: OpsEstateRoute.SETTLEMENT_CANADA.path,
        component: () =>
          import(
            '@/modules/ops/components/presentational/dashboards/EstateSettlementCanadaDashboard.vue'
          )
      },
      {
        path: OpsEstateRoute.SETTLEMENT_US.path,
        name: OpsEstateRoute.SETTLEMENT_US.name,
        component: () =>
          import(
            '@/modules/ops/components/presentational/dashboards/EstateSettlementUSDashboard.vue'
          )
      },
      {
        path: OpsEstateRoute.SETTLEMENT_INACTIVE.path,
        name: OpsEstateRoute.SETTLEMENT_INACTIVE.name,
        component: () =>
          import(
            '@/modules/ops/components/presentational/dashboards/EstateSettlementInactiveDashboard.vue'
          )
      }
    ]
  },
  {
    name: OpsEstateRoute.PLANNING.name,
    path: OpsEstateRoute.PLANNING.path,
    component: () => import('@/modules/ops/pages/EstatePlanningPage.vue'),
    children: [
      {
        name: OpsEstateRoute.PLANNING_CANADA.name,
        path: OpsEstateRoute.PLANNING_CANADA.path,
        component: () =>
          import(
            '@/modules/ops/components/presentational/dashboards/EstatePlanningCanadaDashboard.vue'
          )
      },
      {
        name: OpsEstateRoute.PLANNING_US.name,
        path: OpsEstateRoute.PLANNING_US.path,
        component: () =>
          import('@/modules/ops/components/presentational/dashboards/EstatePlanningUSDashboard.vue')
      },
      {
        name: OpsEstateRoute.PLANNING_INACTIVE.name,
        path: OpsEstateRoute.PLANNING_INACTIVE.path,
        component: () =>
          import(
            '@/modules/ops/components/presentational/dashboards/EstatePlanningInactiveDashboard.vue'
          )
      }
    ]
  }
];
